import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-moment-mat',
  templateUrl: './moment-mat.component.html',
  styleUrls: ['./moment-mat.component.scss']
})
export class MomentMatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
